function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M163.3 75.8c-5.5 0-10.1-4.5-10.1-10.1V2.4H54.8C41 2.4 29.6 13.7 29.6 27.6v201.2c0 13.8 11.3 25.2 25.2 25.2h146.7c13.8 0 25.2-11.3 25.2-25.2v-153z",
  style: {
    fill: "#d12424"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.6 75.7h64L153.4 2.4v64c.3 5 4.3 9 9.2 9.3",
  style: {
    fill: "#e2e2e2"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.7 128V76.1h-63.6z",
  style: {
    fill: "#911616"
  }
}), /*#__PURE__*/React.createElement("text", {
  style: {
    fill: "#fff",
    fontFamily: "&quot",
    fontSize: "76.7185px"
  },
  transform: "translate(63.55 207.524)"
}, ".pdf"));
export default SvgPdf;